import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import Helper from '../../Helper';
import Alert from '../sub/dialog';
import './Transport.css'; // Import CSS for print styling
import moment from 'moment';
const TransportPrint = ({ data }) => {
    const navigate = useNavigate();

    const [company, setCompany] = useState({
        name: '',
        name_en: '',
        address: '',
        phone: '',
        email: '',
        website: '',
        taxid: '', bankaccount: '', bankaccountname: '', bankname: '', bankaccounttype: ''

    });
    const alert = useRef();
    const printRef = useRef();
    let { name, id } = useParams();
    const [transport, setTransport] = useState([]);
    const setError = (message) => alert.current.showerror(message);
    const handlePrint = useReactToPrint({
        documentTitle: 'ใบงานขนส่ง',
        contentRef: printRef,
    });

    const getTransport = async (name) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportJob/${name}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }

            });

            if (response.ok) {
                const data = await response.json();
                setTransport(data.transport);
                console.log(data.transport[0]);
            } else {
                const data = await response.json();
                setError(data.message || 'Failed to fetch transport list');
            }
        } catch (err) {
            setError('An error occurred while fetching the transport list.');
        }
    };
    const fetchCompany = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/GetcompanyProfile`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data) setCompany(data);
        } catch (error) {
            setError('Error fetching company profile:', error);
        }
    };


    useEffect(() => {
        // Get the token from sessionStorage


        if (!["user", "admin"].includes(Helper.getuserrole())) {
            navigate('/main');
            return;
        }
        if (!name) {
            navigate('/main');
            return;
        }
        fetchCompany();
        getTransport(name);



    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', flexDirection: 'column' }}>
            <style type="text/css" media="print">{"\
  @page {\ size:A4 landscape;\ }\
"}</style>
            <Alert ref={alert} />
            <button className='btn btn-info mb-4 mt-4' onClick={handlePrint}>Print</button>
            <div ref={printRef}>
                <div className='transport page-container'>
                    {transport && transport.filter(el => (id ? el.id == id : true)).map((record, i) => (
                        <div key={i} style={{ width: '148mm', height: '210mm', padding: '10mm', border: '1px solid #000' }}>
                            <div style={{ zoom: '0.75' }}>
                                <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '20px' }}>
                                    <img src="/company.png" alt="Company Logo" style={{ width: 'auto', height: '80px', marginRight: '20px' }} />
                                    <div style={{ textAlign: 'center', flex: 1 }}>
                                        <b>{company.name_en}</b>
                                        <div>{company.address}</div>
                                        <div>{company.phone}</div>
                                    </div>
                                </div>

                                <table className='sameheight' style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                                    <tbody style={{ border: '1px solid #000' }}>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td style={{ width: '40%' }} colSpan={3}><span className='me-1'>ใบงานวิ่งรถ</span><span className='me-1'>วันที่</span>{moment(record.jobdate).format("DD-MM-YYYY")}</td>


                                            <td style={{ width: '30%' }} colSpan={2}>
                                                <span>พขร/ทะเบียน</span>
                                            </td>
                                            <td style={{ width: '30%' }} colSpan={2}>
                                                <b>{record.lcplate}</b>
                                            </td>
                                        </tr>
                                        <tr >
                                            <td style={{ width: '15%' }}><b>เลขที่เอกสาร</b></td><td colSpan={4}><b>{record.name}</b></td>
                                            <td style={{ textAlign: "right", paddingRight: "20px" }}><b>แผ่นที่ {i + 1}/{transport.length}</b></td>
                                        </tr>

                                        {/* 
                                   <tr>
                                   <td></td>
                                   <td>{record.customername}</td>
                                   <td></td>
                                   <td colSpan={3}>{record.destination}</td>
                                    </tr>
                                     */}
                                        <tr><td style={{ width: '15%' }}>ชื่อลูกค้า</td>
                                            <td colSpan={2}>
                                                <b className='underline'>{record.jobname}</b>
                                            </td>
                                            <td style={{ width: '15%' }}>สถานที่จัดส่ง</td>
                                            <td colSpan={3}>
                                                <b className='underline'>{record.destination}</b>
                                            </td>
                                        </tr>
                                        <tr><td >BL:</td>
                                            <td className='' colSpan={2}><span className='underline'>{record.bl}</span></td>
                                            <td>จำนวน</td>
                                            <td colSpan={3}><span className='underline'><span className='me-4'>{record.amount}</span><span className='me-1'>เบอร์ตู้</span><span className=''>{record.boxno}</span></span></td>
                                        </tr>
                                        <tr>
                                            <td>คืนตู้ภายใน</td>
                                            <td colSpan={2}><span className='underline'><span className='me-1'>{record.returnboxduration}</span>วัน</span></td>
                                            <td>สถานที่คืนตู้</td>
                                            <td colSpan={3}><span className='underline'>{record.returnboxdestination}</span></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={7}><u className='me-1'>ลูกค้า</u><span className='me-1'>ผู้ว่าจ้าง</span><b>{record.customername}</b></td>

                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={7} style={{ textAlign: "center" }}><h4 style={{ paddingTop: "5px" }}><b>ที่อยู่ออกใบเสร็จ</b></h4></td>

                                        </tr>
                                        <tr className='address'>
                                            <td className='p-2' colSpan={7} >{record.receiptaddress1}</td>
                                        </tr>
                                        <tr className='address'>
                                            <td className='p-2' colSpan={7}>{record.receiptaddress2}</td>
                                        </tr>
                                        <tr className='address'>
                                            <td className='p-2' colSpan={7}>{record.receiptaddress3}</td>
                                        </tr>
                                        <tr className='address'>
                                            <td className='p-2' colSpan={7}>{record.receiptaddress4}</td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={7} style={{ textAlign: "center" }}><h4 style={{ paddingTop: "5px" }}>สรุปค่าใช้จ่าย</h4></td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} style={{ border: '1px solid #000' }}>รายการ</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}>จำนวนเงิน</td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}>หมายเหตุ</td>
                                        </tr>
                                        {/* <tr style={{ border: '1px solid #000' }}>
                                        <td colSpan={3}  style={{ border: '1px solid #000'}}>ค่า</td>
                                        <td  style={{ border: '1px solid #000' , textAlign: "center" }}></td>
                                        <td colSpan={3} style={{ border: '1px solid #000' ,textAlign: "center"  }}></td>
                                    </tr> */}

                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} style={{ border: '1px solid #000' }}>ค่าผ่านลาน / ค่าคืนตู้ / ค่ารับตู้เปล่า</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>

                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} style={{ border: '1px solid #000' }}>ค่าผ่านท่าเรือ</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>

                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} style={{ border: '1px solid #000' }}>ค่าซ่อมตู้ / ล้างตู้</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>

                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} style={{ border: '1px solid #000' }}>ค่าฝากตู้</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>

                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} style={{ border: '1px solid #000' }}>ค่าทางด่วน</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} style={{ border: '1px solid #000' }}>ค่าภาระท่าเรือ / Rent</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} style={{ border: '1px solid #000' }}>ค่าล่วงเวลา</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} className='ps-2' style={{ border: '1px solid #000' }}>ค่าใช้จ่ายอื่นๆ</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} className='ps-2' style={{ border: '1px solid #000' }}>ค่าใช้จ่ายอื่นๆ</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} style={{ border: '1px solid #000' }}>รวม</td>
                                            <td style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                            <td colSpan={3} style={{ border: '1px solid #000', textAlign: "center" }}></td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} >ผู้เบิกเงิน</td>
                                            <td colSpan={4} >วันที่เบิก</td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} >ผู้ตรวจสอบ</td>
                                            <td colSpan={4} >วันที่ตรวจสอบ</td>
                                        </tr>
                                        <tr style={{ border: '1px solid #000' }}>
                                            <td colSpan={3} >บัญชี</td>
                                            <td colSpan={4} >วันที่รับวางบิล</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TransportPrint;